module.exports = __webpack_public_path__ + "static/media/creditCards.6c99febc.svg";